var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Date"},[_c('span',[_vm._v(_vm._s(`${_vm.d || 0}天${_vm.h || 0}小时${_vm.m || 0}分${_vm.s || 0}秒`))])])
}
var staticRenderFns = []

export { render, staticRenderFns }